import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import ThreeDotMenu from './ThreeDotMenu'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { withStyles } from '@material-ui/core/styles'
import colors from '../../configuration/colors'
import { useSelector } from 'react-redux'
import { useTheme } from 'styled-components'

const styles = () => ({
  root: {
    fontSize: '13px',
    fontWeight: 700,
    color: colors.dove,
    paddingLeft: '12px',
    paddingTop: '0',
    paddingBottom: '0'
  }
})

const MutateMenu = ({
  classes,
  item,
  anchorEl,
  handleOpen,
  handleClose,
  lockDeletion,
  allowEdit,
  onEdit,
  userIsConsideringDeleting,
  openOnClick,
  isJourney
}) => {
  const theme = useTheme()
  const isGuardian = useSelector(state => state.auth.user.guardian_user)

  const handleHover = e => {
    if (!openOnClick) {
      handleOpen(e)
    }
  }

  const handleClick = e => {
    if (openOnClick) {
      e.preventDefault()
      e.stopPropagation()
      handleOpen(e)
    }
  }

  return (
    <Fragment>
      {!isGuardian &&
        <ThreeDotMenu
          onHover={handleHover}
          onClick={handleClick}
          isJourney={isJourney}
        />
      }
      <ClickAwayListener onClickAway={handleClose}>
        <Menu
          keepMounted
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          disableAutoFocusItem
          PaperProps={{
            style: {
              width: '122px',
              marginLeft: '8px',
              background: theme?.cardBackground
            }
          }}
          MenuListProps={{
            style: {
              padding: '5px 0'
            }
          }}
        >
          {allowEdit && (
            <MenuItem
              onClick={e => {
                e.preventDefault()
                e.stopPropagation()
                onEdit(item)
              }}
              classes={{
                root: classes.root
              }}
            >
              Edit
            </MenuItem>
          )}
          {!lockDeletion && (
            <MenuItem
              onClick={!lockDeletion ? userIsConsideringDeleting : null}
              classes={{
                root: classes.root
              }}
            >
              Delete
            </MenuItem>
          )}
        </Menu>
      </ClickAwayListener>
    </Fragment>
  )
}

MutateMenu.propTypes = {
  classes: PropTypes.object,
  objectOfMutation: PropTypes.object,
  anchorEl: PropTypes.object,
  handleOpen: PropTypes.func,
  handleClose: PropTypes.func,
  lockDeletion: PropTypes.bool,
  allowEdit: PropTypes.bool,
  onEdit: PropTypes.func,
  userIsConsideringDeleting: PropTypes.bool
}

export default withStyles(styles)(MutateMenu)
